import { render, staticRenderFns } from "./industryPackageDetails.vue?vue&type=template&id=61af1bc7&scoped=true"
import script from "./industryPackageDetails.vue?vue&type=script&lang=js"
export * from "./industryPackageDetails.vue?vue&type=script&lang=js"
import style0 from "./industryPackageDetails.vue?vue&type=style&index=0&id=61af1bc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af1bc7",
  null
  
)

export default component.exports